import React from 'react';

type SocialLink = {
  href: string;
  label: string;
  mark: string;
};

const socialLinks: SocialLink[] = [
  {
    href: 'https://www.linkedin.com/in/jason-conci-82256b161/',
    label: 'LinkedIn',
    mark: 'in',
  },
  {
    href: 'https://www.github.com/jasonjconci',
    label: 'GitHub',
    mark: 'GH',
  },
  {
    href: 'https://open.spotify.com/user/conchshell_?si=Iy_95iJLTyKWjJ4gY_OELQ',
    label: 'Spotify',
    mark: '♫',
  },
  {
    href: 'https://photos.app.goo.gl/BPHvRkcy8yk661RT9',
    label: 'Google Photos',
    mark: 'G',
  },
];

const LegacyHeader: React.FC = () => (
  <header className="legacy-header">
    <a className="legacy-name" href="/legacy">
      Jason Conci
    </a>
    <nav className="legacy-socials" aria-label="Social profiles">
      {socialLinks.map(({ href, label, mark }) => (
        <a
          className="legacy-social-link"
          href={href}
          key={label}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          title={label}
        >
          {mark}
        </a>
      ))}
    </nav>
  </header>
);

export default LegacyHeader;
